/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    20/06/2018
 */
import { City } from '@lemsar/common/domains/models/addressing';

export class ChangePassword {
    public old_password: string;
    public new_password: string;
    public confirmation_password: string;
}

export class UpdateProfile {
    public email: string;
    public name: string;
}

export class AdminCity {
    public id: string;
    public city: City;
}

export class CreateAdminCity {
    public email: string;
    public city: string;
}

export class CreateAdmin {
    public email: string;
}

export class UpdateAdminCity {
    public city: string;
}



// WEBPACK FOOTER //
// ./src/lemsar/user/domains/models/user.ts